import React, { memo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { Typography, Button, Hidden } from '@material-ui/core';
import { keyEmptyCheck } from 'aurora-utils/utils';
import filterIcon from 'aurora-images/filter-icon.svg';
import SearchField from '../SearchField';

import styles from './styles';

const TopFilters = ({
  classes,
  title,
  requiredFilters,
  showSearchField,
  searchFieldPlaceHolder,
  searchFieldValue,
  isActiveFilters,
  searchFieldChangeHandler,
  searchHandler,
  showFiltersModalHandler,
}) => {
  return (
    <div
      className={classNames(classes.topFiltersContainer, {
        [classes.topFiltersContainerMobile]: showSearchField,
      })}
    >
      {title && (
        <Hidden xsDown>
          <Typography variant='h5' className={classes.title}>
            {keyEmptyCheck(title)}
          </Typography>
        </Hidden>
      )}
      <div className={classes.filtersContainer}>
        {showSearchField && (
          <div className={classes.searchFieldContainer}>
            <SearchField
              value={searchFieldValue}
              placeHolder={searchFieldPlaceHolder}
              onChange={searchFieldChangeHandler}
              onSearchHandler={searchHandler}
            />
          </div>
        )}
        {!isEmpty(requiredFilters) && (
          <Hidden xsDown>
            <Button
              className={classNames(classes.showModalBtn, {
                [classes.showModalBtnActive]: isActiveFilters === true,
              })}
              onClick={showFiltersModalHandler}
            >
              <img className={classes.showModalBtnIcon} src={filterIcon} alt='Filter Icon' />
              <Typography variant='h5' className={classes.showModalBtnText}>
                {keyEmptyCheck('Filters')}
              </Typography>
            </Button>
          </Hidden>
        )}
      </div>
    </div>
  );
};

TopFilters.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  requiredFilters: PropTypes.array.isRequired,
  showSearchField: PropTypes.bool.isRequired,
  searchFieldPlaceHolder: PropTypes.string.isRequired,
  searchFieldValue: PropTypes.string.isRequired,
  isActiveFilters: PropTypes.bool.isRequired,
  searchFieldChangeHandler: PropTypes.func.isRequired,
  searchHandler: PropTypes.func.isRequired,
  showFiltersModalHandler: PropTypes.func.isRequired,
};

TopFilters.defaultProps = {};
export default withStyles(styles)(memo(TopFilters));
